












import { Component, Prop, Vue } from 'vue-property-decorator'
import { User } from '@/types/frontend'
import { Icon, Select } from '@alpha/ink'
import EditMetaDataModal, { SelectOption } from '@/components/TestDetails/EditMetaDataModal.vue'

@Component({
  components: {
    Select,
    Icon,
    EditMetaDataModal
  }
})
export default class EditFollowers extends Vue {
  @Prop({ required: true }) readonly followers!: User[]
  @Prop({ required: true }) readonly users!: User[]

  get nonFollowerOptions (): SelectOption[] {
    const nonFollowers = this.users.filter((user) => {
      return !this.followers.find((follower) => {
        return follower.id === user.id
      })
    })

    return nonFollowers.map(this.userToSelectOption)
  }

  get followerOptions (): SelectOption[] {
    return this.followers.map(this.userToSelectOption)
  }

  userToSelectOption (user: User): SelectOption {
    return ({
      label: user.fullName,
      id: user.id
    })
  }

  follow (userId: string) {
    const user = this.users.find((u) => { return u.id === userId })
    this.$emit('editFollower', {
      user,
      follow: true
    })
  }

  unfollow (userId: string) {
    const user = this.users.find((u) => { return u.id === userId })
    this.$emit('editFollower', {
      user,
      follow: false
    })
  }
}

